export default {
  tenantPendingHint: '付款信息已提交，等待财务审核。审核通过后将开通对应套餐权益。',
  packageName: '套餐名称',
  years: "{n} 年",
  reviewTitle: "对公转账审核",
  pending: "待审核",
  approved: "已通过",
  rejected: "已拒绝",
  purchaseKind: "购买类型",
  kind_member_plan: "会员套餐",
  kind_resource_recharge: "资源充值",
  kind_sxa_service: "商协会套餐",
  submittedAt: "提交时间",
  viewReceipt: "查看转账凭证",
  reviewNote: "审核备注",
  approve: "确认到账",
  reject: "拒绝",
  approveConfirm: "请核实银行实际到账情况。确认后将开通套餐或发放充值资源。可填写审核备注：",
  rejectConfirm: "拒绝后订单将关闭，购买方可重新下单。请填写拒绝原因：",
  confirmTitle: '确认购买{name}', method: '付款方式', selected: '已选择', confirmPay: '确认付款 ¥{amount}',
  noMethods: '暂无可用付款方式，请联系平台管理员。', free: '此套餐免费，确认后即可开通。',
  paymentHint: '微信支付成功后自动开通；对公转账提交凭证后，需等待财务审核。',
  loadFailed: '加载付款方式失败，请重试。', failed: '操作失败，请重试。',
  transferTitle: '填写转账信息并提交审核', due: '应付', receivingAccount: '平台对公收款账户',
  accountName: '收款单位', bankName: '开户银行', bankAccount: '银行账号', bankBranch: '开户支行', financeContact: '财务联系方式', reference: '转账备注',
  transferHint: '请按订单金额转账，并上传转账凭证。财务确认到账后开通套餐或发放充值资源。',
  payerName: '付款单位', payerBank: '付款银行', payerAccount: '付款账号', amount: '转账金额（元）',
  transferredAt: '转账时间', transactionNo: '银行流水号', remark: '转账备注', receipt: '上传转账凭证',
  receiptHelp: '支持 PNG / JPG / WebP，最大 500 KB。', required: '请填写或上传{field}',
  amountMismatch: '转账金额必须与订单应付金额一致。', submitReview: '提交审核',
  submitted: '转账信息已提交，等待财务审核。', cancelFailed: '取消订单失败，请重试。', pendingReview: '待财务审核'
}
